function trimStr(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s;
}

/**
 * Cotización con cliente ya vinculado (datos útiles para cabecera PDF).
 */
export function cotizacionTieneClienteVinculado(cotizacionData) {
  const c = cotizacionData?.cliente;
  if (!c) return false;
  return Boolean(
    c.id ||
      trimStr(c.nombreComercial) ||
      trimStr(c.razonSocial) ||
      trimStr(c.ruc)
  );
}

function truncateDisplay(text, maxLen) {
  const s = trimStr(text);
  if (!s) return "";
  if (maxLen == null || maxLen <= 0 || s.length <= maxLen) return s;
  return `${s.substring(0, maxLen)}...`;
}

/**
 * Nombre para cabecera PDF: cliente (nombre comercial / razón social) o lead.
 * @param {number|null|undefined} maxLen — si es null/undefined, sin truncar (p. ej. diálogo de prueba).
 */
export function nombreDisplayClienteCotizacionPdf(cotizacionData, maxLen = 25) {
  if (cotizacionTieneClienteVinculado(cotizacionData)) {
    const c = cotizacionData.cliente;
    const fromCliente =
      trimStr(c.nombreComercial) ||
      trimStr(c.razonSocial) ||
      "";
    if (fromCliente) return truncateDisplay(fromCliente, maxLen);
  }

  const lead = cotizacionData?.lead;
  const fromLead =
    trimStr(cotizacionData?.leadNombre) ||
    trimStr(lead?.leadName) ||
    trimStr(lead?.nombreComercial) ||
    trimStr(lead?.brandName) ||
    "";

  return truncateDisplay(fromLead, maxLen);
}

/** RUC del cliente o documento del lead (RUC / DNI). */
export function docIdentidadClienteCotizacionPdf(cotizacionData) {
  if (cotizacionTieneClienteVinculado(cotizacionData)) {
    const r = trimStr(cotizacionData?.cliente?.ruc);
    if (r) return r;
  }
  return (
    trimStr(cotizacionData?.leadRUC) ||
    trimStr(cotizacionData?.leadDNI) ||
    trimStr(cotizacionData?.lead?.leadDNI) ||
    ""
  );
}

/** "Razón Social" si hay cliente o es factura; si no, "Cliente" (solo lead). */
export function etiquetaNombreClienteCotizacionPdf(cotizacionData) {
  const esFactura = cotizacionData?.tipo !== "Cotizacion";
  if (esFactura || cotizacionTieneClienteVinculado(cotizacionData)) {
    return "Razón Social";
  }
  return "Cliente";
}
